var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSound = function SvgSound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14.5 11",
    style: {
      enableBackground: "new 0 0 14.5 11"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.4,0.1C7-0.1,6.5,0,6.1,0.3L2.9,3H1.2C0.6,3,0,3.6,0,4.2v2.5C0,7.4,0.6,8,1.2,8h1.6l3.3,2.7 C6.4,10.9,6.6,11,6.9,11c0.2,0,0.4,0,0.5-0.1c0.4-0.2,0.7-0.6,0.7-1.1V1.2C8.1,0.8,7.9,0.3,7.4,0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.3,2c-0.2-0.3-0.6-0.3-0.8-0.1C9.2,2.1,9.2,2.5,9.4,2.7c1.6,2,1.6,3.7,0.1,5.6C9.3,8.5,9.3,8.9,9.6,9.1 C9.7,9.2,9.8,9.3,10,9.3c0.2,0,0.3-0.1,0.5-0.2C12.3,6.8,12.2,4.3,10.3,2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.7,0.3c-0.2-0.3-0.6-0.3-0.8-0.2c-0.3,0.2-0.3,0.6-0.2,0.8c2.1,3.2,2.2,6.2,0.1,9.2 c-0.2,0.3-0.1,0.6,0.2,0.8c0.1,0.1,0.2,0.1,0.3,0.1c0.2,0,0.4-0.1,0.5-0.3C15.1,7.4,15.1,3.8,12.7,0.3z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sound.9a0c446a.svg";
export { ForwardRef as ReactComponent };